module.exports = __webpack_public_path__ + "static/media/Favorites-dazzle.676e2a1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Favorites-dazzle.jpg
// module id = 131
// module chunks = 0